export enum SortOptions {
  DESC = "DESC",
  ASC = "ASC",
  COUNT_ASC = "COUNT_ASC",
  COUNT_DESC = "COUNT_DESC",
  ALPHABETICAL = "ALPHABETICAL",
}
